import React from "react";
import PropTypes from "prop-types";


type Props = {
  children: React.ReactNode;
  title: string;
  subTitle: string;
};


const MainLayout = (props: Props) => {
  return (
    <section className="w-full">
      <div className="flex flex-row lg:py-10 ">
        {/* 
        <Affix offsetTop={72} className="hidden md:block md:w-1/6 pl-20 pr-20 h-full">
          <div>
            <div className=" sm:mt-20 ml-8 mb-8 hidden sm:block">
              <div className="sm:text-oya-ghana-header-h3 leading-[36px] text-oya-ghana-header-h4 font-bold">
                {props.title}
              </div>
              <div className="sm:text-oya-ghana-body-normal-large text-oya-ghana-body-normal text-oya-ghana-faded-gray">
                {props.subTitle}
              </div>
            </div>
            <div className="hidden sm:block h-[60vh] overflow-auto pb-5 ml-8 border-r-2">
              <div className="sm:block hidden">
                <ul>
                  <li>
                    <NavLink
                      to="/account"
                      className="flex text-sm text-oya-ghana-faded-gray"
                      style={({ isActive }) =>
                        isActive ? activeStyle : undefined
                      }
                    >
                      <img
                        src={require("../img/account.png")}
                        alt="account profile"
                        className="pr-2"
                      />
                      Profile
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/security-details"
                      className="flex text-sm pt-8 text-oya-ghana-faded-gray"
                      style={({ isActive }) =>
                        isActive ? activeStyle : undefined
                      }
                    >
                      <img
                        src={require("../img/lock.png")}
                        alt="account profile"
                        className="pr-2"
                      />
                      Security
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/verification"
                      className="flex text-sm pt-8 text-oya-ghana-faded-gray"
                      style={({ isActive }) =>
                        isActive ? activeStyle : undefined
                      }
                    >
                      <img
                        src={require("../img/check.png")}
                        alt="account profile"
                        className="pr-2"
                      />
                      Verification
                    </NavLink>
                  </li>
                </ul>
              </div>{" "}
            </div>
          </div>
        </Affix> */}

        {/* <div className="mt-28 ml-8 mb-8 sm:hidden block">
            <div className="sm:text-oya-ghana-header-h3 leading-[36px] text-oya-ghana-header-h4 font-bold">
              {props.title}
            </div>
            <div className="sm:text-oya-ghana-body-normal-large text-oya-ghana-body-normal text-oya-ghana-faded-gray">
              {props.subTitle}
            </div>
          </div> */}
        {/* <div className="w-5/6 px-3 md:px-8">{props.children}</div> */}
      </div>
    </section>
  );
};
MainLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

export default MainLayout;
